import moment from "moment-timezone"
export default class HandlerHabitaciones {
  constructor(habitaciones, proveedor_id, ordenPlanes) {
    this.crudas = habitaciones
    this.proveedor_id = proveedor_id
    this.ordenados = []
    this.ordenPlanes = ordenPlanes
    this.ordenar()
  }
  ordenar() {
    let _self = this
    let ordenados = this.uniqueRegimenes().map(clave => {
      const encontrados = _self.crudas.filter(c => _self.mapClavesRegimenes(c) == clave)
      const ordenados = _self.sortByTarifa(encontrados)
      const habitacionesTarifarios =
        ordenados[0]["@attributes"].isTarifario === "true"
          ? { habitaciones: [], tarifarios: ordenados }
          : { habitaciones: ordenados, tarifarios: [] }

      const regimen = _self.mapRegimen(ordenados[0], habitacionesTarifarios)
      return regimen
    })
    if (this.proveedor_id === "11") {
      ordenados = this.sortDisneyDc(ordenados)
    }
    this.ordenados = ordenados
  }
  uniqueRegimenes() {
    const unicos = [...new Set(this.crudas.map(this.mapClavesRegimenes))]
    return unicos
  }
  mapClavesRegimenes(habitacion) {
    const nombre = habitacion.regimen == undefined ? "Sólo habitación" : habitacion.regimen.trim()
    return `${nombre}-${habitacion.regimenDescripcion}`
  }
  mapRegimen(habitacion, { habitaciones, tarifarios }) {
    const nombre = habitacion.regimen == undefined ? "Sólo habitación" : habitacion.regimen.trim()

    const idTarifa = habitacion.idTarifa === undefined ? null : habitacion.idTarifa
    let claveRegimen = nombre
    let clean = claveRegimen
      .split(" ")
      .splice(1)
      .join(" ")
    const clave = clean.length == 0 ? "No espeficica" : clean
    return {
      nombre: nombre,
      descripcion: habitacion.regimenDescripcion,
      clave: nombre + "-" + habitacion.regimenDescripcion,
      tarifarios: tarifarios,
      habitaciones: habitaciones,
      idTarifa: idTarifa,
      claveRegimen: clave,
      orden: this.getOrden(habitacion.comidaTipo)
    }
  }
  sortByTarifa(habitaciones) {
    habitaciones.sort((a, b) => {
      if (a.tarifas.tarifa == undefined) {
        return
      }

      if (parseFloat(a.tarifas.tarifa.venta) < parseFloat(b.tarifas.tarifa.venta)) {
        return -1
      }
      if (parseFloat(a.tarifas.tarifa.venta) > parseFloat(b.tarifas.tarifa.venta)) {
        return 1
      }
      return 0
    })
    return habitaciones
  }
  getOrdenados() {
    return this.ordenados
  }
  sortDisneyDc(regimenes) {
    const distribuidos = this.distribuirHabitaciones(regimenes)
    return distribuidos.promos.concat(distribuidos.anuales).concat(distribuidos.anuales2)
  }
  distribuirHabitaciones(regimenes) {
    let promos = []
    let anuales = []
    let anuales2 = []
    const years4 = [
      moment().format("YYYY"),
      moment()
        .add(1, "years")
        .format("YYYY")
    ]
    const years2 = [
      moment().format("YY"),
      moment()
        .add(1, "years")
        .format("YY")
    ]

    regimenes.forEach(rg => {
      const codigo = rg.descripcion.split("-")[0].trim()
      const last2 = codigo.substring(codigo.length - 2)
      const isAnual = years2.findIndex(a => {
        return last2 == a
      })
      if (isAnual === -1) {
        promos.push(rg)
        return
      }
      const last4 = codigo.substring(codigo.length - 4)
      const isAnual4 = years4.findIndex(a => {
        return last4 == a
      })
      if (isAnual4 === -1) {
        anuales2.push(rg)
        return
      }
      anuales.push(rg)
    })
    return {
      promos: this.sortRegimenes(promos),
      anuales: this.sortRegimenes(anuales),
      anuales2: this.sortRegimenes(anuales2)
    }
  }
  getOrden(id) {
    const orden = this.ordenPlanes.find(o => o.id == id)
    if (orden === undefined) {
      return 100
    }
    return orden.orden
  }
  sortRegimenes(regimenes) {
    regimenes.sort((a, b) => {
      if (parseFloat(a.orden) < parseFloat(b.orden)) {
        return -1
      }
      if (parseFloat(a.orden) > parseFloat(b.orden)) {
        return 1
      }
      return 0
    })
    return regimenes
  }
}
